import {
  Box,
  chakra,
  Flex,
  Image,
  shouldForwardProp,
  Text,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { COMMON_WEB_PATH } from "../../constant";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import { isValidMotionProp, motion } from "framer-motion";
import { useLocation, useNavigate } from "react-router-dom";
import useWebsiteInfo from "../../hook/useWebsiteInfo";
import useCheckLogin from "../../hook/useCheckLogin";
import i18next from "i18next";
import { IoMdInformationCircleOutline } from "react-icons/io";
import TermsModal from "../TermsModal/TermsModal";

const ChakraBox = chakra(motion.div, {
  shouldForwardProp: (prop) =>
    isValidMotionProp(prop) || shouldForwardProp(prop),
});

const AgeCheckModal = () => {
  const { t } = useTranslation();
  const i18n = (key) => t(`common.${key}`);
  const i18nTerms = (key) => t(`Terms And Service.${key}`);
  const i18nPrivacy = (key) => t(`Privacy Policy.${key}`);

  const location = useLocation();
  const { images } = useWebsiteInfo();
  const { isMachineUser, isLoading } = useCheckLogin();

  const [isChecked, setIsChecked] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [showTerms, setShowTerms] = useState(false); // 服務條款
  const [showPrivacy, setShowPrivacy] = useState(false); // 隱私政策

  const navigate = useNavigate();

  // 處理確認按鈕
  const handleConfirm = () => {
    // 設sessionStorage表示點擊過"已滿18歲"按鈕
    sessionStorage.setItem("age-verified", "true");

    if (isChecked) {
      // 如果勾選了 不再顯示
      const expiryDate = dayjs().add(3, "day"); //三天後會過期

      localStorage.setItem(
        "age-verification-expiry-date",
        JSON.stringify({ expiry: expiryDate }),
      ); // 存到 localStorage
    }
    setShowModal(false);
  };

  const toggleCheck = () => {
    setIsChecked(!isChecked);
  };

  // 服務條款點擊
  const handleTermsClick = () => {
    setShowTerms(true);
  };

  // 關閉服務條款
  const handleCloseTerms = () => {
    setShowTerms(false);
  };

  // 隱私政策點擊
  const handlePrivacyClick = () => {
    setShowPrivacy(true);
  };
  // 關閉隱私政策
  const handleClosePrivacy = () => {
    setShowPrivacy(false);
  };

  useEffect(() => {
    // 載入中或機台用戶 不顯示
    if (isLoading || isMachineUser) {
      setShowModal(false);
      return;
    }

    // 檢查當前路徑是否包含 create-machine
    if (location.pathname.includes("create-machine")) {
      setShowModal(false);
      return; // 如果是 create-machine 頁面，直接返回，不執行後面的邏輯
    }

    // 先檢查sessionStorage
    const sessionVerified = sessionStorage.getItem("age-verified");
    if (sessionVerified === "true") {
      setShowModal(false);
      return;
    }
    // sessionStorage 沒有標記，繼續檢查 localStorage
    let isExpired = false;

    try {
      const raw = localStorage.getItem("age-verification-expiry-date");
      if (!raw) {
        // 從未確認過 → 顯示
        setShowModal(true);
        return;
      }
      const parsed = JSON.parse(raw);
      const expiryDate = dayjs(parsed.expiry);
      isExpired = !expiryDate.isValid() || dayjs().isAfter(expiryDate);
    } catch {
      // parse 失敗視為過期
      isExpired = true;
    }

    setShowModal(isExpired);
  }, [location.pathname, isMachineUser, isLoading]); // 路徑改變時重新執行

  return (
    <>
      {showModal && (
        <Flex
          position="fixed"
          top="0"
          left="0"
          right="0"
          bottom="0"
          bg="rgba(0, 0, 0, 0.8)"
          zIndex="1000000"
          backdropFilter="blur(2px)"
          justifyContent="center"
          alignItems="center"
        >
          <ChakraBox
            as={Flex}
            w="520px"
            h="570px"
            // minHeight="600px"
            bgImage={`url('${COMMON_WEB_PATH}/911TW/18age/hintBG.webp')`}
            bgPosition="center"
            bgRepeat="no-repeat"
            bgSize="100% 100%"
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="space-between"
            p={6}
            px={10}
            paddingTop={{ base: "260px", sm: "280px", lg: "240px" }}
            // 根據狀態使用不同的動畫
            initial={{
              opacity: 0,
            }}
            animate={{
              opacity: 1,
            }}
            transition={{ duration: 0.3 }}
          >
            {/* <Flex
            fontSize="24px"
            color="white"
            textAlign="center"
            mt={4}
            bgImage={`url('${COMMON_WEB_PATH}/FlyDragon/hintTitleBG.webp')`}
            bgPosition="center"
            bgRepeat="no-repeat"
            bgSize="100% 100%"
            sx={{ width: "-webkit-fill-available" }}
            justifyContent="center"
            alignItems="center"
          >
            <Image
              src={`${COMMON_WEB_PATH}/FlyDragon/hintWORD.webp`}
              height={{
                base: "50px",
                xl: "60px",
              }}
            />
          </Flex>
          <Image
            src={`${COMMON_WEB_PATH}/FlyDragon/R18_logo.webp`}
            width={{
              base: "120px",
              xl: "165px",
            }}
            my={4}
          /> */}

            <Box
              fontSize={
                ["vi", "th", "id", "cn", "en", " tag"].includes(
                  i18next.language,
                )
                  ? { base: "16px", lg: "20px", xl: "22px" }
                  : { base: "20px", lg: "22px", xl: "26px" }
              }
              color="white"
              textAlign="center"
              mb={1}
            >
              <Text color="#FFF" fontWeight="700">
                {i18n("18Age")}
              </Text>
            </Box>
            <Flex gap={4} fontSize="14px">
              <Flex
                gap={1}
                alignItems="center"
                cursor="pointer"
                onClick={handleTermsClick}
                _hover={{ color: "#e8c3ff" }}
                color="white"
              >
                <IoMdInformationCircleOutline size={20} />
                <Text>{i18nTerms("Terms of Service")}</Text>
              </Flex>
              <Flex
                gap={1}
                alignItems="center"
                cursor="pointer"
                onClick={handlePrivacyClick}
                _hover={{ color: "#e8c3ff" }}
                color="white"
              >
                <IoMdInformationCircleOutline size={20} />
                <Text>{i18nPrivacy("Privacy Policy")}</Text>
              </Flex>
            </Flex>
            <Flex gap={4} my={6} justifyContent="center" alignItems="center">
              <Flex
                // filter={isChecked ? "" : "grayscale(100%)"}
                // cursor={isChecked ? "pointer" : "not-allowed"}
                cursor="pointer"
                justifyContent="center"
                alignItems="center"
                onClick={handleConfirm}
                _hover={{
                  // filter: isChecked ? "brightness(1.1)" : "grayscale(100%)",
                  filter: "brightness(1.1)",
                }}
              >
                <Image
                  src={images.over18BTN}
                  width={{
                    base: "140px",
                    xl: "165px",
                  }}
                />
              </Flex>
              <Flex
                as="button"
                cursor="pointer"
                justifyContent="center"
                alignItems="center"
                _hover={{ filter: "brightness(1.1)" }}
                onClick={() => {
                  navigate(-1);
                }}
              >
                <Image
                  src={images.under18BTN}
                  width={{
                    base: "140px",
                    xl: "165px",
                  }}
                />
              </Flex>
            </Flex>
            <Flex gap={4} alignItems="center" justifyContent="center">
              <Flex
                gap={1}
                alignItems="center"
                justifyContent="center"
                cursor="pointer"
                onClick={toggleCheck}
              >
                <Box position="relative">
                  <Image
                    src={`${COMMON_WEB_PATH}/911TW/18age/clickBoxBG.webp`}
                    width={{
                      base: "35px",
                      xl: "40px",
                    }}
                  />
                  {isChecked && (
                    <Image
                      src={`${COMMON_WEB_PATH}/FlyDragon/greenCheck.svg`}
                      width={{
                        base: "35px",
                        xl: "40px",
                      }}
                      position="absolute"
                      top="0"
                      left="0"
                      right="0"
                      bottom="0"
                    />
                  )}
                </Box>
                <Text
                  color="#e8c3ff"
                  fontWeight="700"
                  fontSize={{ base: "18px", xl: "22px" }}
                >
                  {i18n("noShow")}
                </Text>
              </Flex>
            </Flex>
          </ChakraBox>
        </Flex>
      )}

      {showTerms && <TermsModal onClose={handleCloseTerms} tabIndex={0} />}
      {showPrivacy && <TermsModal onClose={handleClosePrivacy} tabIndex={1} />}
    </>
  );
};

export default AgeCheckModal;
